import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { server } from '../app/conf'
@Injectable({
  providedIn: 'root'
})
export class ComponentDataService {

  constructor(private http:HttpClient) { }
  create(component,componentData){
    console.log("this is componentData ",componentData);
    return this.http.post<any>(`${server}${component}`,componentData);
  }
  createForCde(component,componentData){
    console.log("this is componentData ",componentData);
    return this.http.post<any>(`${server}${component}forcde`,componentData);
  }  
  update(component,componentData){
    return this.http.put<any>(`${server}${component}/${componentData.case_id}/${componentData._id}`,componentData);
  }
  updateForCde(component,componentData){
    return this.http.put<any>(`${server}${component}forcde/${componentData.case_id}/${componentData._id}`,componentData);
  }  
  delete(component,componentData){
    return this.http.delete<any>(`${server}${component}/deletecheck/case/${componentData.case_id}/component/${componentData._id}`);
  }  
  deleteForCde(component,case_id,check_id){
    return this.http.delete<any>(`${server}${component}forcde/deletecheck/case/${case_id}/component/${check_id}`);
  }    
  deleteAllFilesForCde(component,caseId,check_id){
    return this.http.delete<any>(`${server}${component}forcde/deleteallfiles/case/${caseId}/component/${check_id}`);
  }
  uploadFile(component,componentData,file:File){
    const formData = new FormData();

    console.log('in upload  file ',componentData);
    formData.append('componentFile',file,file.name);
    formData.append('fileName',componentData.fileName);
    formData.append("caseId",componentData.caseId);
    formData.append('case',componentData.case);
    formData.append('componentId',componentData._id);
    formData.append('componentName',component);
        
//    formData.append('file',file);
    const header = new HttpHeaders();
    const params = new HttpParams();
    const options = {
      params,
      reportProgress:true,
      headers:header
    }        
    return this.http.post<any>(`${server}${component}/uploadfile`,formData)
  }
  uploadFileForCde(component,componentData,file:File){
    const formData = new FormData();

    console.log('in upload  file ',componentData);
    formData.append('componentFile',file,file.name);
    formData.append('fileName',componentData.fileName);
    formData.append("caseId",componentData.caseId);
    formData.append('case',componentData.case);
    formData.append('componentId',componentData._id);
    formData.append('componentName',component);
        
//    formData.append('file',file);
    const header = new HttpHeaders();
    const params = new HttpParams();
    const options = {
      params,
      reportProgress:true,
      headers:header
    }        
    return this.http.post<any>(`${server}${component}forcde/uploadfile`,formData)
  }  
  uploadProofOfWork(component,componentData,file:File){
    const formData = new FormData();

    console.log('in upload  file ',componentData);
    formData.append('componentFile',file,file.name);
    formData.append('fileName',componentData.fileName);
    formData.append("caseId",componentData.caseId);
    formData.append('case',componentData.case_id);
    formData.append('componentId',componentData._id);
    formData.append('componentName',component);
        
//    formData.append('file',file);
    const header = new HttpHeaders();
    const params = new HttpParams();
    const options = {
      params,
      reportProgress:true,
      headers:header
    }        
    return this.http.post<any>(`${server}${component}/uploadproofofwork`,formData)
  }
  uploadPvProofOfWork(component,componentData,file:File){
    const formData = new FormData();

    console.log('in upload  file ',componentData);
    formData.append('componentFile',file,file.name);
    formData.append('fileName',componentData.fileName);
    formData.append("caseId",componentData.caseId);
    formData.append('case',componentData.case_id);
    formData.append('componentId',componentData._id);
    formData.append('componentName',component);
        
//    formData.append('file',file);
    const header = new HttpHeaders();
    const params = new HttpParams();
    const options = {
      params,
      reportProgress:true,
      headers:header
    }        
    return this.http.post<any>(`${server}${component}/uploadpvproofofwork`,formData)
  }  
  uploadPaymentProof(component,componentData,file:File){
    const formData = new FormData();

    console.log('in upload  file ',componentData);
    formData.append('componentFile',file,file.name);
    formData.append('fileName',componentData.fileName);
    formData.append("caseId",componentData.caseId);
    formData.append('case',componentData.case_id);
    formData.append('componentId',componentData._id);
    formData.append('componentName',component);
        
//    formData.append('file',file);
    const header = new HttpHeaders();
    const params = new HttpParams();
    const options = {
      params,
      reportProgress:true,
      headers:header
    }        
    return this.http.post<any>(`${server}${component}/uploadpaymentproof`,formData)
  }    
  deleteFile(component,componentData,fileName){
    const formData = new FormData();
    formData.append('fileName',fileName);
    formData.append("caseId",componentData.caseId);
    formData.append('case',componentData.case);
    formData.append('componentId',componentData._id);
    formData.append('componentName',component);    
    return this.http.delete<any>(`${server}${component}/deletefile/${componentData.caseId}/${component}/${componentData._id}/${fileName}`);
  }
  deleteFileForCde(component,componentData,fileName){
/*    const formData = new FormData();
    formData.append('fileName',fileName);
    formData.append("caseId",componentData.caseId);
    formData.append('case',componentData.case);
    formData.append('componentId',componentData._id);
    formData.append('componentName',component);    */
    return this.http.delete<any>(`${server}${component}forcde/deletefile/${componentData.caseId}/${component}/${componentData._id}?fileName=${fileName}`);
  }  
  downloadFile(component,componentData,fileName){
//    ?pageCount=${pageCount
      let headers = new HttpHeaders();
//      return this.http.get<Blob>(`${server}${component}/downloadfile/${componentData.caseId}/${component}/${componentData._id}/${fileName}`,{observe:'response',responseType:'blob' as 'json'});
      return this.http.get<Blob>(`${server}${component}/downloadfile/${componentData.caseId}/${component}/${componentData._id}?fileName=${fileName}`,{observe:'response',responseType:'blob' as 'json'});      
  }
  downloadFileForCde(component,componentData,fileName){
    //    ?pageCount=${pageCount
          let headers = new HttpHeaders();
    //      return this.http.get<Blob>(`${server}${component}/downloadfile/${componentData.caseId}/${component}/${componentData._id}/${fileName}`,{observe:'response',responseType:'blob' as 'json'});
          return this.http.get<Blob>(`${server}${component}forcde/downloadfile/${componentData.caseId}/${component}/${componentData._id}?fileName=${fileName}`,{observe:'response',responseType:'blob' as 'json'});      
  }  
  downloadProofOfWork(component,componentData,fileName){
    let headers = new HttpHeaders();
//    return this.http.get<Blob>(`${server}${component}/downloadproofofwork/${componentData.caseId}/${component}/${componentData._id}/${fileName}`,{observe:'response',responseType:'blob' as 'json'});
    return this.http.get<Blob>(`${server}${component}/downloadproofofwork/${componentData.caseId}/${component}/${componentData._id}?fileName=${fileName}`,{observe:'response',responseType:'blob' as 'json'});

  }

  downloadPaymentProofs(component,componentData,fileName){
    let headers = new HttpHeaders();
    return this.http.get<Blob>(`${server}${component}/downloadpaymentproof/${componentData.caseId}/${component}/${componentData._id}?fileName=${fileName}`,{observe:'response',responseType:'blob' as 'json'});

  }  
  
  findOne(component,caseId,componentId){
    return this.http.get<any>(`${server}${component}/findone/${caseId}/${componentId}`);
  }
  findOneForCde(component,caseId,serialNumber){
    return this.http.get<any>(`${server}${component}forcde/findone/${caseId}/${serialNumber}`);
  }
  findAllForACase(component,caseId){
    return this.http.get<any[]>(`${server}${component}/${caseId}`);
  }
  updateDataEntryStatus(component,componentData){
    return this.http.put<any>(`${server}${component}/updatedataentrystatus/${componentData.case_id}/${componentData._id}`,componentData);
  }  
  updateInputqcStatus(component,componentData){
    return this.http.put<any>(`${server}${component}/updateinputqcstatus/${componentData.case_id}/${componentData._id}`,componentData);
  }
  allocateCheckToMyself(component,componentData){
    return this.http.put<any>(`${server}${component}/allocatechecktomyself/${componentData.case_id}/${componentData._id}`,componentData);
  }
  allocateCheckToFe(component,componentData){
    return this.http.put<any>(`${server}${component}/allocatechecktofe/${componentData.case_id}/${componentData._id}`,componentData);
  }  
  allocateCheckToVendor(component,componentData){
    return this.http.put<any>(`${server}${component}/allocatechecktovendor/${componentData.case_id}/${componentData._id}`,componentData);
  }    
  updateVerificationStatus(component,componentData){
    return this.http.put<any>(`${server}${component}/updateverificationstatus/${componentData.case_id}/${componentData._id}`,componentData);
  }
  putItToFeBucket(component,componentData){
    return this.http.put<any>(`${server}${component}/putittofebucket/${componentData.case_id}/${componentData._id}`,componentData);
  }    
  putItToVendorBucket(component,componentData){
    return this.http.put<any>(`${server}${component}/putittovendorbucket/${componentData.case_id}/${componentData._id}`,componentData);
  }      
  updateVerifierReviewStatus(component,componentData){
    return this.http.put<any>(`${server}${component}/updateverifierreviewstatus/${componentData.case_id}/${componentData._id}`,componentData);
  }    
  updateFeVerificationStatus(component,componentData){
    return this.http.put<any>(`${server}${component}/updatefeverificationstatus/${componentData.case_id}/${componentData._id}`,componentData);
  }
  updateVendorVerificationStatus(component,componentData){
    return this.http.put<any>(`${server}${component}/updatevendorverificationstatus/${componentData.case_id}/${componentData._id}`,componentData);
  }  
  updateMentorReviewStatus(component,componentData){
    return this.http.put<any>(`${server}${component}/updatementorreviewstatus/${componentData.case_id}/${componentData._id}`,componentData);
  }
  updateOutputqcStatus(component,componentData){
    return this.http.put<any>(`${server}${component}/updateoutputqcstatus/${componentData.case_id}/${componentData._id}`,componentData);
  }        
  approveInsuff2(component,componentData){
    return this.http.put<any>(`${server}${component}/approveinsuff2/${componentData.case_id}/${componentData._id}`,componentData);
  }    
  rejectInsuff2(component,componentData){
    return this.http.put<any>(`${server}${component}/rejectinsuff2/${componentData.case_id}/${componentData._id}`,componentData);
  }      
  rejectInsuff1Clearance(component,componentData){
    return this.http.put<any>(`${server}${component}/rejectinsuff1clearance/${componentData.case_id}/${componentData._id}`,componentData);
  }        
  rejectInsuff2Clearance(component,componentData){
    return this.http.put<any>(`${server}${component}/rejectinsuff2clearance/${componentData.case_id}/${componentData._id}`,componentData);
  }          
  clearInsuff2(component,componentData){
    return this.http.put<any>(`${server}${component}/clearinsuff2/${componentData.case_id}/${componentData._id}`,componentData);
  }        
  clearInsuff1(component,componentData){
    return this.http.put<any>(`${server}${component}/clearinsuff1/${componentData.case_id}/${componentData._id}`,componentData);
  }          
  approveInsuffClearance(component,componentData){
    return this.http.put<any>(`${server}${component}/approveinsuffclearance/${componentData.case_id}/${componentData._id}`,componentData);
  }            
  readFileNames(component,caseId,componentId){
    return this.http.get<any[]>(`${server}${component}/readfilenames/${caseId}/${component}/${componentId}`);
  } 
  readFileNamesForCde(component,caseId,componentId){
    return this.http.get<any[]>(`${server}${component}forcde/readfilenames/${caseId}/${component}/${componentId}`);
  }    
  readProofOfWorks(component,caseId,componentId){
    return this.http.get<any[]>(`${server}${component}/readproofofworks/${caseId}/${component}/${componentId}`);
  }    
  readPaymentProofs(component,caseId,componentId){
    return this.http.get<any[]>(`${server}${component}/readpaymentproofs/${caseId}/${component}/${componentId}`);
  }      
  findComponentsWithInputqcStatus(component,inputqcStatus){
    return this.http.get<any[]>(`${server}${component}/findwithinputqcstatus/${inputqcStatus}`);
  }
  findComponentsFor(component,query){
    return this.http.get<any[]>(`${server}${component}/findcomponentsfor/${query}`);
  }
  findComponentsForVendorManager(component,query,pageCount){
    return this.http.get<any>(`${server}${component}/findcomponentsforvendormanager/${query}?pageCount=${pageCount}`);
  }  
  findUnallocatedComponentsForVerification(component){
    return this.http.get<any[]>(`${server}${component}/find/unallocated/verification`);
  }  
  getAllChecksAllocatedToMeForVerification(component){
    return this.http.get<any[]>(`${server}${component}/user/getallchecksallocatedtomeforverification`);
  }    
  findInsufficienciesForClient(component,pageCount){
    return this.http.get<any[]>(`${server}${component}/insuff/insuffforclient?pageCount=${pageCount}`);
  }
  searchInsufficienciesForClient(component,caseId){
    return this.http.get<any[]>(`${server}${component}/insuff/searchacaseininsuffforclient?caseId=${caseId}`);
  }  
  findInsufficienciesForScrutiny(component){
    return this.http.get<any[]>(`${server}${component}/insuff/insuffforscrutiny`);
  }  
  allocateCheckToVerifier(component,componentData){
    return this.http.put<any>(`${server}${component}/allocatechecktoverifier/${componentData.case_id}/${componentData._id}`,componentData)
  }
  addNote(component,componentData){
    return this.http.put<any>(`${server}${component}/addnote/${componentData.case_id}/${componentData._id}`,componentData)
  }
  stopCheck(component,componentData){
    return this.http.put<any>(`${server}${component}/stopcheck/${componentData.case_id}/${componentData._id}`,componentData);
  }
}
